// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"366e304b","124":"25b8a472","178":"67682daf","303":"c925983c","462":"adafc5e4","591":"d9cd36b1","594":"8768bdc7","638":"4dc84134","674":"90f70a5d","858":"ceb52d70","969":"8d06405c"}[chunkId] + ".chunk.js";
};